<template>
  <div class="page-card">
    <div class="page-card__header">
      <div>
        <div class="page-card__title">
          {{
            id
              ? "Fiskal xatar hujjatini tahrirlash"
              : `Fiskal xatar hujjati qo'shish`
          }}
        </div>
        <div class="page-card__subtitle">
          Har bir til uchun sarlavha, rasm va PDF fayl kiriting
        </div>
      </div>
      <div v-if="id" class="page-card__badge">ID: {{ id }}</div>
    </div>

    <el-form label-position="top" ref="formRef" :model="fiscalRisksModel">
      <el-tabs v-model="activeName">
        <el-tab-pane name="uz">
          <template #label>
            <span class="tab-label">
              <el-icon v-if="!tabIncomplete('uz_lat')" class="tab-label-check"
                ><CircleCheckFilled
              /></el-icon>
              <span v-else class="incomplete-dot" />
              UZB
            </span>
          </template>
          <div class="lang-panel">
            <el-form-item
              label="Sarlavha"
              prop="titleUz"
              :rules="titleRules('Uz')"
            >
              <el-input
                placeholder="Sarlavhani kiriting (Uz)"
                v-model="fiscalRisksModel.titleUz"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <div class="upload-grid">
              <el-form-item
                class="upload-field"
                label="Sarlavha uchun rasm"
                prop="imageUz"
                :rules="[
                  { required: true, message: 'Sarlavha uchun rasm yuklang (Uz)' },
                ]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.imageUz" />
                <input
                  accept="image/jpeg, image/jpg, image/png, image/webp"
                  type="file"
                  @change="uploadImgUz"
                  hidden
                  id="imgUz"
                />
                <label
                  for="imgUz"
                  v-loading="imgLoaderUz"
                  class="dropzone"
                  :class="{ 'is-filled': imgUrlUz }"
                >
                  <template v-if="imgUrlUz">
                    <img :src="imgUrlUz" class="dropzone-preview" alt="" />
                    <div class="dropzone-overlay">
                      <el-icon><Refresh /></el-icon>
                      <span>Almashtirish</span>
                    </div>
                  </template>
                  <template v-else>
                    <el-icon class="dropzone-icon"><Picture /></el-icon>
                    <span class="dropzone-text">Rasm yuklash</span>
                    <span class="dropzone-hint">JPG, PNG, WEBP &middot; max 5MB</span>
                  </template>
                </label>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyImageToAll('uz_lat')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
              <el-form-item
                class="upload-field"
                label="Fayl"
                prop="fileUz"
                :rules="[{ required: true, message: 'Fayl yuklang (Uz)' }]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.fileUz" />
                <input
                  accept="application/pdf"
                  type="file"
                  @change="uploadFileUz"
                  hidden
                  id="fileUz"
                />
                <label
                  for="fileUz"
                  v-loading="fileLoaderUz"
                  class="dropzone"
                  :class="{ 'is-filled': fileUrlUz }"
                >
                  <el-icon class="dropzone-icon" :class="{ 'is-filled': fileUrlUz }"
                    ><Document
                  /></el-icon>
                  <span class="dropzone-text">{{
                    fileUrlUz ? "Yuklangan fayl" : "Fayl yuklash"
                  }}</span>
                  <span class="dropzone-hint">{{
                    fileUrlUz ? "Almashtirish uchun bosing" : "PDF · max 50MB"
                  }}</span>
                </label>
                <a
                  v-if="fileUrlUz"
                  :href="fileUrlUz"
                  target="_blank"
                  class="file-open-link"
                  @click.stop
                >
                  <el-icon><View /></el-icon> Ochish
                </a>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyFileToAll('uz_lat')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane name="uzKr">
          <template #label>
            <span class="tab-label">
              <el-icon v-if="!tabIncomplete('uz_cyr')" class="tab-label-check"
                ><CircleCheckFilled
              /></el-icon>
              <span v-else class="incomplete-dot" />
              UZB Krill
            </span>
          </template>
          <div class="lang-panel">
            <el-form-item
              label="Sarlavha"
              prop="titleUzKr"
              :rules="titleRules('UzKr')"
            >
              <el-input
                placeholder="Sarlavhani kiriting (UzKr)"
                v-model="fiscalRisksModel.titleUzKr"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <div class="upload-grid">
              <el-form-item
                class="upload-field"
                label="Sarlavha uchun rasm"
                prop="imageUzKr"
                :rules="[
                  { required: true, message: 'Sarlavha uchun rasm yuklang (UzKr)' },
                ]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.imageUzKr" />
                <input
                  accept="image/jpeg, image/jpg, image/png, image/webp"
                  type="file"
                  @change="uploadImgUzKr"
                  hidden
                  id="imgUzKr"
                />
                <label
                  for="imgUzKr"
                  v-loading="imgLoaderUzKr"
                  class="dropzone"
                  :class="{ 'is-filled': imgUrlUzKr }"
                >
                  <template v-if="imgUrlUzKr">
                    <img :src="imgUrlUzKr" class="dropzone-preview" alt="" />
                    <div class="dropzone-overlay">
                      <el-icon><Refresh /></el-icon>
                      <span>Almashtirish</span>
                    </div>
                  </template>
                  <template v-else>
                    <el-icon class="dropzone-icon"><Picture /></el-icon>
                    <span class="dropzone-text">Rasm yuklash</span>
                    <span class="dropzone-hint">JPG, PNG, WEBP &middot; max 5MB</span>
                  </template>
                </label>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyImageToAll('uz_cyr')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
              <el-form-item
                class="upload-field"
                label="Fayl"
                prop="fileUzKr"
                :rules="[{ required: true, message: 'Fayl yuklang (UzKr)' }]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.fileUzKr" />
                <input
                  accept="application/pdf"
                  type="file"
                  @change="uploadFileUzKr"
                  hidden
                  id="fileUzKr"
                />
                <label
                  for="fileUzKr"
                  v-loading="fileLoaderUzKr"
                  class="dropzone"
                  :class="{ 'is-filled': fileUrlUzKr }"
                >
                  <el-icon
                    class="dropzone-icon"
                    :class="{ 'is-filled': fileUrlUzKr }"
                    ><Document
                  /></el-icon>
                  <span class="dropzone-text">{{
                    fileUrlUzKr ? "Yuklangan fayl" : "Fayl yuklash"
                  }}</span>
                  <span class="dropzone-hint">{{
                    fileUrlUzKr ? "Almashtirish uchun bosing" : "PDF · max 50MB"
                  }}</span>
                </label>
                <a
                  v-if="fileUrlUzKr"
                  :href="fileUrlUzKr"
                  target="_blank"
                  class="file-open-link"
                  @click.stop
                >
                  <el-icon><View /></el-icon> Ochish
                </a>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyFileToAll('uz_cyr')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane name="ru">
          <template #label>
            <span class="tab-label">
              <el-icon v-if="!tabIncomplete('ru')" class="tab-label-check"
                ><CircleCheckFilled
              /></el-icon>
              <span v-else class="incomplete-dot" />
              RU
            </span>
          </template>
          <div class="lang-panel">
            <el-form-item
              label="Sarlavha"
              prop="titleRu"
              :rules="titleRules('Ru')"
            >
              <el-input
                placeholder="Sarlavhani kiriting (Ru)"
                v-model="fiscalRisksModel.titleRu"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <div class="upload-grid">
              <el-form-item
                class="upload-field"
                label="Sarlavha uchun rasm"
                prop="imageRu"
                :rules="[
                  { required: true, message: 'Sarlavha uchun rasm yuklang (Ru)' },
                ]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.imageRu" />
                <input
                  accept="image/jpeg, image/jpg, image/png, image/webp"
                  type="file"
                  @change="uploadImgRu"
                  hidden
                  id="imgRu"
                />
                <label
                  for="imgRu"
                  v-loading="imgLoaderRu"
                  class="dropzone"
                  :class="{ 'is-filled': imgUrlRu }"
                >
                  <template v-if="imgUrlRu">
                    <img :src="imgUrlRu" class="dropzone-preview" alt="" />
                    <div class="dropzone-overlay">
                      <el-icon><Refresh /></el-icon>
                      <span>Almashtirish</span>
                    </div>
                  </template>
                  <template v-else>
                    <el-icon class="dropzone-icon"><Picture /></el-icon>
                    <span class="dropzone-text">Rasm yuklash</span>
                    <span class="dropzone-hint">JPG, PNG, WEBP &middot; max 5MB</span>
                  </template>
                </label>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyImageToAll('ru')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
              <el-form-item
                class="upload-field"
                label="Fayl"
                prop="fileRu"
                :rules="[{ required: true, message: 'Fayl yuklang (Ru)' }]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.fileRu" />
                <input
                  accept="application/pdf"
                  type="file"
                  @change="uploadFileRu"
                  hidden
                  id="fileRu"
                />
                <label
                  for="fileRu"
                  v-loading="fileLoaderRu"
                  class="dropzone"
                  :class="{ 'is-filled': fileUrlRu }"
                >
                  <el-icon class="dropzone-icon" :class="{ 'is-filled': fileUrlRu }"
                    ><Document
                  /></el-icon>
                  <span class="dropzone-text">{{
                    fileUrlRu ? "Yuklangan fayl" : "Fayl yuklash"
                  }}</span>
                  <span class="dropzone-hint">{{
                    fileUrlRu ? "Almashtirish uchun bosing" : "PDF · max 50MB"
                  }}</span>
                </label>
                <a
                  v-if="fileUrlRu"
                  :href="fileUrlRu"
                  target="_blank"
                  class="file-open-link"
                  @click.stop
                >
                  <el-icon><View /></el-icon> Ochish
                </a>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyFileToAll('ru')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane name="en">
          <template #label>
            <span class="tab-label">
              <el-icon v-if="!tabIncomplete('en')" class="tab-label-check"
                ><CircleCheckFilled
              /></el-icon>
              <span v-else class="incomplete-dot" />
              ENG
            </span>
          </template>
          <div class="lang-panel">
            <el-form-item
              label="Sarlavha (En)"
              prop="titleEn"
              :rules="titleRules('En')"
            >
              <el-input
                placeholder="Sarlavhani kiriting (En)"
                v-model="fiscalRisksModel.titleEn"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <div class="upload-grid">
              <el-form-item
                class="upload-field"
                label="Sarlavha uchun rasm"
                prop="imageEn"
                :rules="[
                  { required: true, message: 'Sarlavha uchun rasm yuklang (En)' },
                ]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.imageEn" />
                <input
                  accept="image/jpeg, image/jpg, image/png, image/webp"
                  type="file"
                  @change="uploadImgEn"
                  hidden
                  id="imgEn"
                />
                <label
                  for="imgEn"
                  v-loading="imgLoaderEn"
                  class="dropzone"
                  :class="{ 'is-filled': imgUrlEn }"
                >
                  <template v-if="imgUrlEn">
                    <img :src="imgUrlEn" class="dropzone-preview" alt="" />
                    <div class="dropzone-overlay">
                      <el-icon><Refresh /></el-icon>
                      <span>Almashtirish</span>
                    </div>
                  </template>
                  <template v-else>
                    <el-icon class="dropzone-icon"><Picture /></el-icon>
                    <span class="dropzone-text">Rasm yuklash</span>
                    <span class="dropzone-hint">JPG, PNG, WEBP &middot; max 5MB</span>
                  </template>
                </label>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyImageToAll('en')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
              <el-form-item
                class="upload-field"
                label="Fayl"
                prop="fileEn"
                :rules="[{ required: true, message: 'Fayl yuklang (En)' }]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.fileEn" />
                <input
                  accept="application/pdf"
                  type="file"
                  @change="uploadFileEn"
                  hidden
                  id="fileEn"
                />
                <label
                  for="fileEn"
                  v-loading="fileLoaderEn"
                  class="dropzone"
                  :class="{ 'is-filled': fileUrlEn }"
                >
                  <el-icon class="dropzone-icon" :class="{ 'is-filled': fileUrlEn }"
                    ><Document
                  /></el-icon>
                  <span class="dropzone-text">{{
                    fileUrlEn ? "Yuklangan fayl" : "Fayl yuklash"
                  }}</span>
                  <span class="dropzone-hint">{{
                    fileUrlEn ? "Almashtirish uchun bosing" : "PDF · max 50MB"
                  }}</span>
                </label>
                <a
                  v-if="fileUrlEn"
                  :href="fileUrlEn"
                  target="_blank"
                  class="file-open-link"
                  @click.stop
                >
                  <el-icon><View /></el-icon> Ochish
                </a>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyFileToAll('en')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane name="kp">
          <template #label>
            <span class="tab-label">
              <el-icon v-if="!tabIncomplete('kr')" class="tab-label-check"
                ><CircleCheckFilled
              /></el-icon>
              <span v-else class="incomplete-dot" />
              KP
            </span>
          </template>
          <div class="lang-panel">
            <el-form-item
              label="Sarlavha (Kp)"
              prop="titleKp"
              :rules="titleRules('Kp')"
            >
              <el-input
                placeholder="Sarlavhani kiriting (Kp)"
                v-model="fiscalRisksModel.titleKp"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <div class="upload-grid">
              <el-form-item
                class="upload-field"
                label="Sarlavha uchun rasm"
                prop="imageKp"
                :rules="[
                  { required: true, message: 'Sarlavha uchun rasm yuklang (Kp)' },
                ]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.imageKp" />
                <input
                  accept="image/jpeg, image/jpg, image/png, image/webp"
                  type="file"
                  @change="uploadImgKp"
                  hidden
                  id="imgKp"
                />
                <label
                  for="imgKp"
                  v-loading="imgLoaderKp"
                  class="dropzone"
                  :class="{ 'is-filled': imgUrlKp }"
                >
                  <template v-if="imgUrlKp">
                    <img :src="imgUrlKp" class="dropzone-preview" alt="" />
                    <div class="dropzone-overlay">
                      <el-icon><Refresh /></el-icon>
                      <span>Almashtirish</span>
                    </div>
                  </template>
                  <template v-else>
                    <el-icon class="dropzone-icon"><Picture /></el-icon>
                    <span class="dropzone-text">Rasm yuklash</span>
                    <span class="dropzone-hint">JPG, PNG, WEBP &middot; max 5MB</span>
                  </template>
                </label>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyImageToAll('kr')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
              <el-form-item
                class="upload-field"
                label="Fayl"
                prop="fileKp"
                :rules="[{ required: true, message: 'Fayl yuklang (Kp)' }]"
              >
                <el-input hidden v-model.number="fiscalRisksModel.fileKp" />
                <input
                  accept="application/pdf"
                  type="file"
                  @change="uploadFileKp"
                  hidden
                  id="fileKp"
                />
                <label
                  for="fileKp"
                  v-loading="fileLoaderKp"
                  class="dropzone"
                  :class="{ 'is-filled': fileUrlKp }"
                >
                  <el-icon class="dropzone-icon" :class="{ 'is-filled': fileUrlKp }"
                    ><Document
                  /></el-icon>
                  <span class="dropzone-text">{{
                    fileUrlKp ? "Yuklangan fayl" : "Fayl yuklash"
                  }}</span>
                  <span class="dropzone-hint">{{
                    fileUrlKp ? "Almashtirish uchun bosing" : "PDF · max 50MB"
                  }}</span>
                </label>
                <a
                  v-if="fileUrlKp"
                  :href="fileUrlKp"
                  target="_blank"
                  class="file-open-link"
                  @click.stop
                >
                  <el-icon><View /></el-icon> Ochish
                </a>
                <button
                  type="button"
                  class="copy-link"
                  @click="copyFileToAll('kr')"
                >
                  <el-icon><CopyDocument /></el-icon>
                  Barcha tillarga nusxalash
                </button>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div class="form-footer">
        <el-alert
          v-if="id"
          type="warning"
          :closable="false"
          show-icon
          class="footer-alert"
          title="Saqlangandan so'ng yuklab olishlar soni 0 dan boshlanadi."
        />
        <div class="footer-actions">
          <el-button plain @click="goBack">Bekor qilish</el-button>
          <el-button
            type="primary"
            :disabled="anyUploading"
            :loading="loading"
            @click="submitForm(formRef)"
            >Saqlash</el-button
          >
        </div>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  CircleCheckFilled,
  CopyDocument,
  Document,
  Picture,
  Refresh,
  View,
} from "@element-plus/icons-vue";
import store from "@/store";
import http from "@/http";
import router from "@/router";
import { useRoute } from "vue-router";

const baseUrl = process.env.VUE_APP_BASE_API_URL + "api/v2/info/file/";
const formRef = ref();
const loading = ref(false);
const initializing = ref(true);
const dirty = ref(false);
const imgUrlUz = ref(null);
const imgUrlUzKr = ref(null);
const imgUrlRu = ref(null);
const imgUrlEn = ref(null);
const imgUrlKp = ref(null);
const fileNameUz = ref(null);
const fileNameUzKr = ref(null);
const fileNameRu = ref(null);
const fileNameEn = ref(null);
const fileNameKp = ref(null);
const imgLoaderUz = ref(false);
const imgLoaderUzKr = ref(false);
const fileLoaderUz = ref(false);
const fileLoaderUzKr = ref(false);
const imgLoaderRu = ref(false);
const fileLoaderRu = ref(false);
const imgLoaderEn = ref(false);
const fileLoaderEn = ref(false);
const imgLoaderKp = ref(false);
const fileLoaderKp = ref(false);
const fileUrlUz = ref(null);
const fileUrlUzKr = ref(null);
const fileUrlRu = ref(null);
const fileUrlEn = ref(null);
const fileUrlKp = ref(null);
const activeName = ref("uz");
const route = useRoute();
const { id } = route.params;
const fiscalRisksModel = reactive({
  titleUz: "",
  titleUzKr: "",
  titleRu: "",
  titleEn: "",
  titleKp: "",
  imageUz: "",
  imageUzKr: "",
  imageRu: "",
  imageEn: "",
  imageKp: "",
  fileUz: "",
  fileUzKr: "",
  fileRu: "",
  fileEn: "",
  fileKp: "",
});
const attachments = reactive({
  uz_lat: null,
  uz_cyr: null,
  ru: null,
  en: null,
  kr: null,
});
const images = reactive({
  uz_lat: null,
  uz_cyr: null,
  ru: null,
  en: null,
  kr: null,
});

const LANGS = ["uz_lat", "uz_cyr", "ru", "en", "kr"];
const modelTitleKeys = {
  uz_lat: "titleUz",
  uz_cyr: "titleUzKr",
  ru: "titleRu",
  en: "titleEn",
  kr: "titleKp",
};
const modelImageKeys = {
  uz_lat: "imageUz",
  uz_cyr: "imageUzKr",
  ru: "imageRu",
  en: "imageEn",
  kr: "imageKp",
};
const modelFileKeys = {
  uz_lat: "fileUz",
  uz_cyr: "fileUzKr",
  ru: "fileRu",
  en: "fileEn",
  kr: "fileKp",
};
const imgUrlRefs = {
  uz_lat: imgUrlUz,
  uz_cyr: imgUrlUzKr,
  ru: imgUrlRu,
  en: imgUrlEn,
  kr: imgUrlKp,
};
const fileUrlRefs = {
  uz_lat: fileUrlUz,
  uz_cyr: fileUrlUzKr,
  ru: fileUrlRu,
  en: fileUrlEn,
  kr: fileUrlKp,
};
const fileNameRefs = {
  uz_lat: fileNameUz,
  uz_cyr: fileNameUzKr,
  ru: fileNameRu,
  en: fileNameEn,
  kr: fileNameKp,
};

const tabIncomplete = (lang) => {
  const title = fiscalRisksModel[modelTitleKeys[lang]];
  return !title || !title.trim() || !images[lang] || !attachments[lang];
};

const titleRules = (label) => [
  { required: true, message: `Sarlavha majburiy (${label})` },
  { max: 512, message: `Sarlavha 512 belgidan oshmasligi kerak (${label})` },
  {
    validator: (rule, value, callback) => {
      if (value && !value.trim()) {
        callback(new Error(`Sarlavha bo'sh bo'lishi mumkin emas (${label})`));
      } else {
        callback();
      }
    },
    trigger: "blur",
  },
];

const anyUploading = computed(
  () =>
    imgLoaderUz.value ||
    imgLoaderUzKr.value ||
    imgLoaderRu.value ||
    imgLoaderEn.value ||
    imgLoaderKp.value ||
    fileLoaderUz.value ||
    fileLoaderUzKr.value ||
    fileLoaderRu.value ||
    fileLoaderEn.value ||
    fileLoaderKp.value
);

watch(
  [fiscalRisksModel, attachments, images],
  () => {
    if (!initializing.value) {
      dirty.value = true;
    }
  },
  { deep: true }
);

const copyImageToAll = (fromLang) => {
  const source = images[fromLang];
  if (!source?.file_id) {
    ElMessage.warning("Avval ushbu til uchun rasm yuklang");
    return;
  }
  LANGS.forEach((lang) => {
    if (lang === fromLang) return;
    fiscalRisksModel[modelImageKeys[lang]] = source.file_id;
    imgUrlRefs[lang].value = baseUrl + source.file_id;
    images[lang] = { file_id: source.file_id, lang, type: "IMAGE" };
  });
  ElMessage.success("Rasm barcha tillarga nusxalandi");
};

const copyFileToAll = (fromLang) => {
  const source = attachments[fromLang];
  if (!source?.file_id) {
    ElMessage.warning("Avval ushbu til uchun fayl yuklang");
    return;
  }
  LANGS.forEach((lang) => {
    if (lang === fromLang) return;
    fiscalRisksModel[modelFileKeys[lang]] = source.file_id;
    fileUrlRefs[lang].value = baseUrl + source.file_id;
    fileNameRefs[lang].value = fileNameRefs[fromLang].value;
    attachments[lang] = { file_id: source.file_id, lang, type: "ATTACHMENT" };
  });
  ElMessage.success("Fayl barcha tillarga nusxalandi");
};

const uploadImgUz = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      imgLoaderUz.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlUz.value = baseUrl + data.hashId;
          fiscalRisksModel.imageUz = data.hashId;
          images.uz_lat = {
            file_id: data.hashId,
            lang: "uz_lat",
            type: "IMAGE",
          };
          resolve(imgUrlUz);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderUz.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadImgUzKr = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      imgLoaderUzKr.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlUzKr.value = baseUrl + data.hashId;
          fiscalRisksModel.imageUzKr = data.hashId;
          images.uz_cyr = {
            file_id: data.hashId,
            lang: "uz_cyr",
            type: "IMAGE",
          };
          resolve(imgUrlUzKr);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderUzKr.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadImgRu = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      imgLoaderRu.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlRu.value = baseUrl + data.hashId;
          fiscalRisksModel.imageRu = data.hashId;
          images.ru = {
            file_id: data.hashId,
            lang: "ru",
            type: "IMAGE",
          };
          resolve(imgUrlRu);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderRu.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadImgEn = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      imgLoaderEn.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlEn.value = baseUrl + data.hashId;
          fiscalRisksModel.imageEn = data.hashId;
          images.en = {
            file_id: data.hashId,
            lang: "en",
            type: "IMAGE",
          };
          resolve(imgUrlEn);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderEn.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadImgKp = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      imgLoaderKp.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlKp.value = baseUrl + data.hashId;
          fiscalRisksModel.imageKp = data.hashId;
          images.kr = {
            file_id: data.hashId,
            lang: "kr",
            type: "IMAGE",
          };
          resolve(imgUrlKp);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderKp.value = false;
        });
    } else {
      reject("");
    }
  });
};

const uploadFileUz = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);
    fileNameUz.value = file.name;
    if (fileValidate) {
      fileLoaderUz.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          fiscalRisksModel.fileUz = data.hashId;
          fileUrlUz.value = baseUrl + data.hashId;
          attachments.uz_lat = {
            file_id: data.hashId,
            lang: "uz_lat",
            type: "ATTACHMENT",
          };
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderUz.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadFileUzKr = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);
    fileNameUzKr.value = file.name;
    if (fileValidate) {
      fileLoaderUzKr.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          fiscalRisksModel.fileUzKr = data.hashId;
          fileUrlUzKr.value = baseUrl + data.hashId;
          attachments.uz_cyr = {
            file_id: data.hashId,
            lang: "uz_cyr",
            type: "ATTACHMENT",
          };
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderUzKr.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadFileRu = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    fileNameRu.value = file.name;
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      fileLoaderRu.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          fiscalRisksModel.fileRu = data.hashId;
          fileUrlRu.value = baseUrl + data.hashId;
          attachments.ru = {
            file_id: data.hashId,
            lang: "ru",
            type: "ATTACHMENT",
          };
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderRu.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadFileEn = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    fileNameEn.value = file.name;
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      fileLoaderEn.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          fiscalRisksModel.fileEn = data.hashId;
          fileUrlEn.value = baseUrl + data.hashId;
          attachments.en = {
            file_id: data.hashId,
            lang: "en",
            type: "ATTACHMENT",
          };
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderEn.value = false;
        });
    } else {
      reject("");
    }
  });
};

const uploadFileKp = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    fileNameKp.value = file.name;
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      fileLoaderKp.value = true;
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          fiscalRisksModel.fileKp = data.hashId;
          fileUrlKp.value = baseUrl + data.hashId;
          attachments.kr = {
            file_id: data.hashId,
            lang: "kr",
            type: "ATTACHMENT",
          };
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderKp.value = false;
        });
    } else {
      reject("");
    }
  });
};

const goBack = () => {
  if (dirty.value) {
    ElMessageBox.confirm(
      "Saqlanmagan o'zgarishlar bor. Chiqishni tasdiqlaysizmi?",
      "Diqqat!",
      {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      }
    )
      .then(() => router.push("/app/fiscal-risks"))
      .catch(() => {});
  } else {
    router.push("/app/fiscal-risks");
  }
};

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      loading.value = true;
      http({
        url: `api/v1/posts/fiscal-risks${id ? `/${id}` : ""}`,
        params: { cache: "off" },
        data: {
          title: {
            uz_lat: fiscalRisksModel.titleUz?.trim() || "",
            uz_cyr: fiscalRisksModel.titleUzKr?.trim() || "",
            ru: fiscalRisksModel.titleRu?.trim() || "",
            en: fiscalRisksModel.titleEn?.trim() || "",
            kr: fiscalRisksModel.titleKp?.trim() || "",
          },
          attachments: Object.values(attachments).filter(Boolean),
          images: Object.values(images).filter(Boolean),
        },
        method: id ? "put" : "post",
        headers: {},
      })
        .then(() => {
          ElMessage.success(id ? "Hujjat yangilandi" : "Hujjat qo'shildi");
          dirty.value = false;
          router.push("/app/fiscal-risks");
        })
        .catch((err) => {
          console.log(err);
          ElMessage.error(`Xatolik qayta urinib ko'ring`);
        })
        .finally(() => {
          loading.value = false;
        });
    } else {
      const errors = [];
      for (const keys in fields) {
        fields[keys].map((item) => {
          errors.push(item);
        });
      }
      errors.map((error) => {
        ElMessage.error(error.message);
      });
      console.log("error submit!", fields);
    }
  });
};
const beforeUploadFile = (rawFile) => {
  if (!rawFile) {
    return false;
  }
  const isImage = ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(
    rawFile.type
  );
  const isPdf = rawFile.type === "application/pdf";
  if (!isImage && !isPdf) {
    ElMessage.error(`Fayl JPG, JPEG, PNG, WEBP yoki PDF bo'lishi mumkin!`);
    return false;
  }
  const maxMb = isPdf ? 50 : 5;
  if (rawFile.size / 1024 / 1024 > maxMb) {
    ElMessage.error(`Fayl hajmi max. ${maxMb}Mb bo'lishi kerak!`);
    return false;
  }
  return true;
};
onMounted(async () => {
  if (id) {
    try {
      const { data } = await http.get(`api/v1/posts/fiscal-risks/${id}`, {
        params: { cache: "off" },
      });
      fiscalRisksModel.titleUz = data.title?.uz_lat || "";
      fiscalRisksModel.titleUzKr = data.title?.uz_cyr || "";
      fiscalRisksModel.titleRu = data.title?.ru || "";
      fiscalRisksModel.titleEn = data.title?.en || "";
      fiscalRisksModel.titleKp = data.title?.kr || "";

      for (let img of data.images) {
        if (img.lang === "uz_lat") {
          fiscalRisksModel.imageUz = img.file_id;
          imgUrlUz.value = baseUrl + img.file_id;
          images.uz_lat = {
            file_id: img.file_id,
            lang: "uz_lat",
            type: "IMAGE",
          };
        }
        if (img.lang === "uz_cyr") {
          fiscalRisksModel.imageUzKr = img.file_id;
          imgUrlUzKr.value = baseUrl + img.file_id;
          images.uz_cyr = {
            file_id: img.file_id,
            lang: "uz_cyr",
            type: "IMAGE",
          };
        }
        if (img.lang === "ru") {
          fiscalRisksModel.imageRu = img.file_id;
          imgUrlRu.value = baseUrl + img.file_id;
          images.ru = {
            file_id: img.file_id,
            lang: "ru",
            type: "IMAGE",
          };
        }
        if (img.lang === "en") {
          fiscalRisksModel.imageEn = img.file_id;
          imgUrlEn.value = baseUrl + img.file_id;
          images.en = {
            file_id: img.file_id,
            lang: "en",
            type: "IMAGE",
          };
        }
        if (img.lang === "kr") {
          fiscalRisksModel.imageKp = img.file_id;
          imgUrlKp.value = baseUrl + img.file_id;
          images.kr = {
            file_id: img.file_id,
            lang: "kr",
            type: "IMAGE",
          };
        }
      }
      for (let attachment of data.attachments) {
        if (attachment.lang === "uz_lat") {
          fiscalRisksModel.fileUz = attachment.file_id;
          fileUrlUz.value = baseUrl + attachment.file_id;
          attachments.uz_lat = {
            file_id: attachment.file_id,
            lang: "uz_lat",
            type: "ATTACHMENT",
          };
        }
        if (attachment.lang === "uz_cyr") {
          fiscalRisksModel.fileUzKr = attachment.file_id;
          fileUrlUzKr.value = baseUrl + attachment.file_id;
          attachments.uz_cyr = {
            file_id: attachment.file_id,
            lang: "uz_cyr",
            type: "ATTACHMENT",
          };
        }
        if (attachment.lang === "ru") {
          fiscalRisksModel.fileRu = attachment.file_id;
          fileUrlRu.value = baseUrl + attachment.file_id;
          attachments.ru = {
            file_id: attachment.file_id,
            lang: "ru",
            type: "ATTACHMENT",
          };
        }
        if (attachment.lang === "en") {
          fiscalRisksModel.fileEn = attachment.file_id;
          fileUrlEn.value = baseUrl + attachment.file_id;
          attachments.en = {
            file_id: attachment.file_id,
            lang: "en",
            type: "ATTACHMENT",
          };
        }
        if (attachment.lang === "kr") {
          fiscalRisksModel.fileKp = attachment.file_id;
          fileUrlKp.value = baseUrl + attachment.file_id;
          attachments.kr = {
            file_id: attachment.file_id,
            lang: "kr",
            type: "ATTACHMENT",
          };
        }
      }
    } finally {
      initializing.value = false;
    }
  } else {
    initializing.value = false;
  }
});
</script>

<style scoped lang="scss">
.page-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 5px 10px #f1f2fa;
  padding: 24px 28px 28px;
}

.page-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.page-card__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1f2937;
}

.page-card__subtitle {
  margin-top: 4px;
  font-size: 0.82rem;
  color: #909399;
}

.page-card__badge {
  font-size: 0.75rem;
  color: #46607e;
  background: #f1f4f8;
  padding: 4px 12px;
  border-radius: 20px;
  white-space: nowrap;
}

:deep(.el-tabs__header) {
  margin-bottom: 20px;
}

:deep(.el-tabs__item) {
  height: 44px;
  font-weight: 600;
}

.tab-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.tab-label-check {
  color: #16a34a;
  font-size: 16px;
}

.incomplete-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--el-color-danger);
  display: inline-block;
}

.lang-panel {
  padding-top: 4px;
}

.upload-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  max-width: 620px;
}

.upload-field :deep(.el-form-item__content) {
  flex-direction: column;
  align-items: flex-start;
}

.dropzone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 150px;
  border: 1.5px dashed #d7dbe4;
  border-radius: 10px;
  background: #fafbfd;
  color: #8a94a6;
  cursor: pointer;
  padding: 16px;
  text-align: center;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  overflow: hidden;
}

.dropzone:hover {
  border-color: var(--el-color-primary);
  background: #f2f9fb;
  color: var(--el-color-primary);
}

.dropzone.is-filled {
  border-style: solid;
  border-color: #dce5ea;
  background: #fff;
  padding: 0;
}

.dropzone-icon {
  font-size: 26px;
}

.dropzone-icon.is-filled {
  color: var(--el-color-primary);
  font-size: 22px;
}

.dropzone-text {
  font-size: 0.85rem;
  font-weight: 600;
  color: #606266;
}

.dropzone.is-filled .dropzone-text {
  color: #1f2937;
}

.dropzone-hint {
  font-size: 0.72rem;
  color: #aab2c0;
}

.dropzone-preview {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dropzone-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: rgba(15, 23, 42, 0.55);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.dropzone:hover .dropzone-overlay {
  opacity: 1;
}

.copy-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.78rem;
  color: var(--el-color-primary);
}

.copy-link:hover {
  text-decoration: underline;
}

.file-open-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  font-size: 0.8rem;
  color: var(--el-color-primary);
  text-decoration: none;
}

.form-footer {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.footer-alert {
  flex: 1;
  min-width: 260px;
}

.footer-actions {
  display: flex;
  gap: 10px;
  margin-left: auto;
}
</style>
